
const ADD = 'dice/add';
const REMOVE = 'dice/remove';
const COLOR = 'dice/color';
const UNDO = 'app/undo';
const REDO = 'app/redo';
const FIXPOS = 'dice/position';
const CLEAR = 'app/clear';


export { ADD, REMOVE, COLOR, UNDO, REDO, FIXPOS, CLEAR };

